import styled, { css } from 'styled-components';
import { StickTo } from '../../Table.decl';

var computeStickyStyle = function computeStickyStyle(theme, stickTo, stuck) {
  var style = '';

  if (stickTo) {
    style += 'position: sticky; top: 0; z-index: 0;';

    if (stickTo === StickTo.Left) {
      style += 'left: 0;';

      if (!stuck) {
        style += "border-right: 1px solid " + theme.colors.grey.light + ";";
      }
    } else {
      style += 'right: 0;';

      if (!stuck) {
        style += "border-left: 1px solid " + theme.colors.grey.light + ";";
      }
    }
  }

  return style;
};

export var StyledHeader = styled.th.withConfig({
  displayName: "styled__StyledHeader",
  componentId: "sc-1fmgyli-0"
})(function (_ref) {
  var theme = _ref.theme,
      stickTo = _ref.stickTo,
      stuck = _ref.stuck;
  return css(["display:table-cell;padding:0 ", "px;height:48px;text-align:left;border-bottom:1px solid ", ";background:", ";white-space:nowrap;", ""], theme.space.s, theme.colors.grey.light, theme.colors.grey.lighter, computeStickyStyle(theme, stickTo, stuck));
});